import styled from "@mui/styled-engine-sc";
import { palette } from "../../../themes/color-palette";

export const StyledProductRecommended = styled("div")`
  ${({ theme }) => `
    background: ${palette.blue.background};
    color: ${palette.white.main};
    padding-bottom: ${theme.spacing(20)};

    ${theme.breakpoints.down("sm")} {
      padding-right: 0;
      padding-bottom: ${theme.spacing(10)};
    }

    .keen-slider.overflow-visible {
      overflow: visible;
    }

    &.bg-beige {
      background: ${palette.beige.light};
      color: ${palette.text.primary};
    }

    &.modal {
      padding-bottom: ${theme.spacing(5)};
      border-radius: 0 0 8px 8px;

      .arrow-big {
        top: calc(50% + 52px);
      }
    }

    &.order-page {
      padding-bottom: 0;
    }

    .product-recommended {
      position: relative;

      .keen-slider.justify-center {
        justify-content: center;
        gap: 20px;
      }

      &.padding-mobile{
        padding-left: 12px;
        padding-right: 0px;
      }

      // ${theme.breakpoints.up("sm")} {
      // &.pdp-product-recommended{
      //   margin-right: 0;
      //   margin-left: 130px;
      //   max-width: fit-content;
      //   padding-right: 0;

      //   .arrow-big.arrow--right{
      //         right: 152px;
      //   }
      // }

      // @media (min-width:1200px) {
      //    &.pdp-product-recommended{
      //     margin-left: 50px;
      //    }
      // }
      }
    }
  `}
`;
